// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};


$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initLazyLoad();
    app.initLazyVideos();
    app.initLightbox();
    app.initSlickCarousel();
    app.scrollToAnchor();
    //app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();
    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatepicker();
    app.enquiryDatepickers();
    app.initWowJs();
    app.initStickyEl();
    app.initTooltips();
    app.keepTokenAlive();
    app.announcementBarDismiss();
    app.showScrollIcon();
    app.initSpotlightJs();
    app.initTingleModalJs();
    app.initSearchBar();

    // let googleMaps = require('./modules/google-maps')();
    // googleMaps.assign();


    $(".megamenu").on("click", function (e) {
        e.stopPropagation();
    });


    /** Import Vehicle modules **/
    /*let vehicles = require('../../../vendor/csone/cms-vehicles/src/resources/js/modules/vehicles')();
    vehicles.enquiryDatepickers();
    vehicles.enquiryTimepickers();
    vehicles.salesListFilters();*/


    /** Import Vehicle modules **/
    /*let plant_hire = require('./modules/plant-hire')();
    plant_hire.enquiryDatepickers();
    plant_hire.cartInit();*/

    /*Filter Submit*/
    $('.autosubmit').change(function () {
        $('body').addClass('loading');
        $(this).parents('form').submit();
    });

    /*Search*/
    $(function () {
        let timeout = null;

        $('#GlobalSearch').keyup(function () {
            $('.results-container').html('').addClass('d-none');

            //clearTimeout(timeout); // this will clear the recursive unneccessary calls

            //timeout = setTimeout(() => {

            if (window.google_tag_manager)
                gtag('event', 'search', {
                    'event_category': 'engagement',
                    'event_label': $(this).val()
                });

            $.ajax({
                type: 'POST',
                url: '/api/search',
                data: {search: $(this).val()},
                dataType: 'json',
                headers: {'x-csrf-token': $('meta[name=csrf-token]').attr('content')},
                statusCode: {
                    200: function (result) {
                        console.log(result);

                        if (result.count)
                            $('.results-container').removeClass('d-none').html(result.html)

                        return true;
                    },

                    500: function (xhr) {
                        $('.results-container').addClass('d-none')
                        return false;
                    }
                }
            });
            //, 100);

        }).on('focusout', function () {

            setTimeout(function () {
                $('.results-container').html('').addClass('d-none');
            }, 200);
        });


        $('.hide-on-submit').click(function () {
            $(this).attr('disabled', 'disabled')
                .addClass('rounded-max')
                .html('<i class="fa fa-spin fa-spinner"></i>');
            $(this).parents('form').submit();
        });
    });


});


$.fn.serializeObject = function () {
    "use strict";

    var result = {};
    var extend = function (i, element) {
        var node = result[element.name];

        // If node with same name exists already, need to convert it to an array as it
        // is a multi-value field (i.e., checkboxes)

        if ('undefined' !== typeof node && node !== null) {
            if ($.isArray(node)) {
                node.push(element.value);
            } else {
                result[element.name] = [node, element.value];
            }
        } else {
            result[element.name] = element.value;
        }
    };

    $.each(this.serializeArray(), extend);
    return result;
};
